import { defineMessages, type MessageDescriptor } from 'react-intl';

// Explicit annotation required by --isolatedDeclarations.
export const messages: Record<string, MessageDescriptor> = defineMessages({
	code: {
		id: 'search-page.search-page-relay.search-results.search-result.search-result-renderer.search-graph-code.code',
		defaultMessage: 'Code',
		description: 'Type label for GitHub code search results.',
	},
});
